import { getFacilityKey } from "../../../utils/token";
import { apiPrivateAxiosWithBaseURL } from "../../axios";
import { IAdminFacilityData } from "./types";

const API_URL_ADMIN = process.env.REACT_APP_API_URL_ADMIN;

export const adminFacilityRequest = {
  getFacilityAdminDetails: (): Promise<IAdminFacilityData> => {
    const facilityKey = localStorage.getItem('facilityKey');
    return apiPrivateAxiosWithBaseURL.get(`/facility/${facilityKey}`, {
      baseURL: API_URL_ADMIN
    })
  }
};
